import _ from 'lodash'
import Backbone from 'backbone'
import FormView from 'scoreboard/components/form-view'
import renderFieldDropdown from 'scoreboard/datasets/render-field-dropdown'
import template from './data-type-field-selector.hbs'
import Dataset from 'scoreboard/datasets/model/dataset'
import isGeographicDataType from 'scoreboard/components/is-geographic-data-type'

const DataTypeFieldSelector = Backbone.View.extend({

	tagName: 'form',

	/**
	 * @type Dataset
	 */
	dataset: null,

	/**
	 * @param {ChartDesignerSerie} [options.model] - the serie to update
	 * @param {Object} [options.datasets] - datasets objects (not Dataset models) keyed
	 * by ID that are needed for the initially selected data source settings
	 */
	initialize: function(options = {}) {
		this.options = options
		this.model = options.model
		this.datasets = options.datasets
		this.dataSource = this.model.getGenericDataSource()
		if (this.dataSource.startingDatasetId) {
			this.dataset = new Dataset(this.datasets[this.dataSource.startingDatasetId])
		}

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			test: () => this.test()
		})
	},

	render: function() {
		this.$el.html(template(this.context()))

		var el = this.$('[name=fieldIdentifier]')

		const selectedId = this.dataset.idsToFieldIdentifier({
			fieldId: this.model.get(this.options.fieldIdAttr),
			visibleLinkedFieldId: this.model.get(this.options.linkedFieldIdAttr)
		})
		this.initialField = this.dataset.getUnderlyingField(selectedId)
		this.currentField = renderFieldDropdown({
			el,
			dataset: this.dataset,
			allowedFieldIds: this._getAllowedFieldIds(),
			allowedVisibleLinkedFieldIds: this._getAllowedVlfIds(),
			selectedId,
			required: true,
			includeTotal: false,
			includeNativeTotal: false,
			filterVisibleLinkedFields: true
		})

		this.formView.start()
	},

	context: function() {
		const fieldType = this.options.fieldType
		return {
			title: `charts.chart.series.set${_.capitalize(fieldType)}Field`,
			fieldIdentifierLabel: `charts.chart.series.${fieldType}Field`
		}
	},

	_getAllowedFieldIds: function() {
		return _(this.dataset.get('fields'))
			.filter(f => {
				let underlyingField = this.dataset.getUnderlyingField(f)
				return this.isCorrectDataType(underlyingField)
			})
			.map('id')
			.value()
	},

	_getAllowedVlfIds: function() {
		return _(this.dataset.get('visibleLinkedFields'))
			.filter(vlf => {
				let field = this.dataset.combinedFieldsById[vlf.fieldId]
				return this.isCorrectDataType(field)
			})
			.map('id')
			.value()
	},

	isCorrectDataType: function(field) {
		const fieldType = this.options.fieldType
		return field &&
			((fieldType === 'geographic' && isGeographicDataType(field.dataType))
			|| (fieldType !== 'geographic' && fieldType === field.dataType))
	},

	_getSelectedField: function() {
		const fieldId = this.$('[name="fieldIdentifier"]').val()
		let field = this.dataset.getUnderlyingField(
			this.dataset.getFieldByFieldIdentifier(fieldId))

		return _.extend({},
			field,
			this.dataset.fieldIdentifierToIds(fieldId),
			{ initialField: this.initialField })
	},

	test: function() {
		if (!this._getSelectedField()) {
			return `charts.chart.series.${this.options.fieldType}FieldRequired`
		}
	},

	submit: function() {
		this.trigger('done', this._getSelectedField())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([ this.formView, this.currentField, this.initialField ],
			'remove')
	}
})

export default DataTypeFieldSelector
DataTypeFieldSelector.__filename__ = 'charts/edit/serie/data-type-field-selector.js'
